import React from "react";
import { Link } from "react-router-dom";
import { Wrench, ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";

export const BreakdownAssistPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f5f6f6] text-[#111619]" data-testid="breakdown-page">
      <header className="border-b border-[#cfd7db] bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-5 flex items-center justify-between">
          <Link to="/" data-testid="breakdown-home-link"><Logo variant="group" size="md" /></Link>
          <Link
            to="/"
            className="font-display uppercase tracking-widest text-xs text-[#3f4b52] hover:text-[#f28a16] transition flex items-center gap-2"
            data-testid="breakdown-back"
          >
            <ArrowLeft size={14} /> Back
          </Link>
        </div>
      </header>

      <main className="flex-1 hero-gradient relative flex items-center">
        <div className="max-w-3xl mx-auto px-6 md:px-10 py-24 text-center fade-up">
          <div className="h-20 w-20 mx-auto rounded-md bg-white/10 border border-white/20 backdrop-blur-sm flex items-center justify-center mb-8">
            <Wrench size={36} className="text-[#ffc438]" />
          </div>
          <div className="font-display uppercase tracking-widest text-xs text-[#ffc438] mb-4">
            Division 02 · Mobile Breakdown Assist
          </div>
          <h1 className="font-display font-black uppercase leading-[0.9] text-4xl sm:text-5xl lg:text-6xl text-white">
            Coming <span className="text-[#ffc438]">Soon</span>
          </h1>
          <p className="mt-6 text-white/85 text-base sm:text-lg leading-relaxed">
            We're putting the finishing touches on the Diesel & Dust Mobile
            Breakdown Assist division. Roadside, mechanical and recovery
            services — built for South African road conditions — are on the way.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/windscreens"
              className="inline-flex items-center justify-center bg-[#f28a16] text-white font-display uppercase tracking-widest text-sm px-8 h-12 rounded-md hover:brightness-110 transition shadow-lg"
              data-testid="breakdown-visit-windscreens"
            >
              Visit Windscreens Division
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center border border-white/30 text-white font-display uppercase tracking-widest text-sm px-8 h-12 rounded-md hover:border-[#ffc438] hover:text-[#ffc438] transition"
              data-testid="breakdown-back-home"
            >
              Back to Group Home
            </Link>
          </div>
        </div>
      </main>

      <footer className="border-t border-[#cfd7db] py-6 text-center text-xs text-[#3f4b52] bg-[#edf2f4]">
        © {new Date().getFullYear()} Diesel & Dust Group ·{" "}
        <Link
          to="/terms"
          className="text-[#f28a16] hover:underline font-semibold"
          data-testid="breakdown-terms-link"
        >
          Terms &amp; Conditions
        </Link>{" "}
        apply
      </footer>
    </div>
  );
};

export default BreakdownAssistPage;
